import { render, staticRenderFns } from "./account-copy.vue?vue&type=template&id=90dd93ae"
import script from "./account-copy.vue?vue&type=script&lang=js"
export * from "./account-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports